import { Button, useToast } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { parse } from 'fter'
import { useState } from 'react'
import { useRender } from 'redity'
import writeXlsxFile, { Row, SheetData } from 'write-excel-file'
import { get } from '../../../lib/http'
import { ReportSale } from '../../../models/report_sale'
import { controlList } from '../storage'
import DownloadIcon from '../../../components/Icon/Download'

export default function Download() {
    useRender('Download')
    const toast = useToast()
    const [isLoading, setLoading] = useState(false)

    async function download() {
        setLoading(true)
        const start_date = controlList.getQuery('start_date') as string
        const end_date = controlList.getQuery('end_date') as string
        const with_invoices = controlList.getQuery('with_invoices')
        const with_sale_notes = controlList.getQuery('with_sale_notes')
        const with_tickets = controlList.getQuery('with_tickets')
        const path = parse(
            {
                start_date,
                end_date,
                with_invoices,
                with_sale_notes,
                with_tickets
            },
            '/api/reports/sales'
        )

        const { data, error } = await get<ReportSale[]>(path)

        if (error) {
            toast({
                status: 'error',
                title: error.message,
                position: 'top'
            })
            setLoading(false)
            return
        }

        const head: (...values: string[]) => Row[number][] = (...values) =>
            values.map<Row[number]>(val => ({
                value: val,
                fontWeight: 'bold',
                wrap: true,
                alignVertical: 'center',
                align: 'center'
            }))

        const rows: SheetData = [
            [],
            [
                {},
                {},
                {},
                {},
                {
                    value: 'Reporte de Comprobante',
                    fontWeight: 'bold',
                    span: 4,
                    height: 24,
                    alignVertical: 'center',
                    align: 'center',
                    fontSize: 15
                }
            ],
            [
                {},
                {},
                {},
                {},
                {
                    value: `De: ${dayjs(start_date, 'YYYY-MM-DD').format(
                        'DD/MM/YYYY'
                    )} - Hasta: ${dayjs(end_date, 'YYYY-MM-DD').format(
                        'DD/MM/YYYY'
                    )}`,
                    span: 4,
                    align: 'center'
                }
            ],
            [],
            [],
            head(
                'Fecha de emisión',
                'Tipo de comprobante',
                'Comprobante',
                'DNI/RUC',
                'Cliente',
                'Base Imponible Gravada',
                'Base Imponible NO Gravada',
                'IGV',
                'Importe Total',
                'Moneda',
                'Tipo de Cambio',
                'Base Otra Moneda'
            )
        ]

        data.result.forEach(sale => {
            rows.push([
                {
                    value: dayjs(sale.issue_date).format('DD/MM/YYYY'),
                    type: String
                },
                {
                    value: sale.type_voucher,
                    type: String
                },
                {
                    value: `${sale.serie}-${sale.correlative}`,
                    type: String
                },
                {
                    value: sale.document,
                    type: String
                },
                {
                    value: sale.client,
                    type: String
                },
                {
                    value: Number(sale.sub_total),
                    type: Number,
                    format: '#,##0.00'
                },
                {
                    value: Number(sale.sub_total_no_gravada),
                    type: Number,
                    format: '#,##0.00'
                },
                {
                    value: Number(sale.igv),
                    type: Number,
                    format: '#,##0.00'
                },
                {
                    value: sale.total,
                    type: Number,
                    format: '#,##0.00'
                },
                {
                    value: sale.currency,
                    type: String
                },
                {
                    value: sale.type_change,
                    type: String
                },
                {
                    value: sale.base_other_currency,
                    type: String
                }
            ])
        })

        const date = dayjs().format('YYYY_MM_DD_HH_mm_ss')

        await writeXlsxFile(rows, {
            fileName: `Reporte_de_Comprobantes_${date}.xlsx`,
            columns: [
                {
                    width: 12
                },
                {
                    width: 12
                },
                {
                    width: 12
                },
                {
                    width: 12
                },
                {
                    width: 50
                },
                {
                    width: 20
                },
                {
                    width: 20
                },
                {
                    width: 12
                },
                {
                    width: 12
                },
                {
                    width: 12
                },
                {
                    width: 12
                },
                {
                    width: 12
                }
            ],
            fontSize: 10,
            fontFamily: 'Calibri'
        })
        setLoading(false)
    }

    return (
        <Button
            variant="alo-gray:md-xl"
            onClick={download}
            isLoading={isLoading}
            isDisabled={!controlList.getQuery('start_date')}
            rightIcon={<DownloadIcon fill="white" />}
        >
            Descargar
        </Button>
    )
}
